import { render, staticRenderFns } from "./SubmitCorrectionForm.vue?vue&type=template&id=6162ded5"
import script from "./SubmitCorrectionForm.vue?vue&type=script&lang=js"
export * from "./SubmitCorrectionForm.vue?vue&type=script&lang=js"
import style0 from "./SubmitCorrectionForm.vue?vue&type=style&index=0&id=6162ded5&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports